import { Paperclip, X } from "lucide-react";
import { uploadMultiImages } from "../../sdk/upload/upload";
import Loading from "../../shared/Loading";

const Finalize = ({
  closeFinalizeApproval,
  handleApproveLoan,
  handleBackToAmountFromFinalizeApproval,
  approvalDetails,
  setApprovalDetails,
  approvalLoading,
}) => {
  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const uploadedUrls = await uploadMultiImages(files);

    setApprovalDetails((prev) => ({
      ...prev,
      additionalDocuments: [...prev.additionalDocuments, ...uploadedUrls],
    }));
  };

  const handleRemoveFile = (url) => {
    setApprovalDetails((prev) => ({
      ...prev,
      additionalDocuments: prev.additionalDocuments.filter(
        (item) => item !== url,
      ),
    }));
  };
  return (
    <div
      onClick={(e) => {
        closeFinalizeApproval();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[550px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        <div
          onClick={closeFinalizeApproval}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Finalize Loan Approval
          </p>
          <p className="text-[#5C5C5C] font-normal text-[14px]">
            Provide any additional details to support the loan approval. This
            may include internal notes, approval conditions, or any other
            relevant information. Ensure all necessary justifications are
            documented before proceeding.
          </p>
          <div className="my-[10px] w-full">
            <textarea
              className="h-[150px] w-full text-[14px] rounded-[5px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9]"
              placeholder="Add additional information here"
              value={approvalDetails.description}
              onChange={(e) =>
                setApprovalDetails((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>
          {/* Upload input */}
          <input
            type="file"
            accept=".pdf,.docx,.doc,.jpeg,.png"
            multiple
            id="file-upload"
            className="hidden"
            onChange={handleFileUpload}
          />
          <label htmlFor="file-upload" className="cursor-pointer">
            <div className="h-[45px] rounded-[5px] w-full px-[15px] gap-[10px] border border-[#000000] flex items-center">
              <Paperclip size={16} color="#000000" />
              <p className="text-[#000000] text-[16px] font-normal">
                Attach a file (.pdf, .docx, doc, .jpeg, .png)
              </p>
            </div>
          </label>

          {/* Uploaded file list */}
          {approvalDetails.additionalDocuments.length > 0 && (
            <div className="mt-[15px] space-y-2">
              {approvalDetails.additionalDocuments.map((url, index) => {
                const filename = url.split("/").pop();

                return (
                  <div
                    key={url}
                    className="flex items-center justify-between bg-[#F5F5F5] px-[10px] py-[5px] rounded-[5px]"
                  >
                    <p className="text-[14px] text-[#000000] truncate max-w-[90%]">
                      {filename}
                    </p>
                    <button
                      onClick={() => handleRemoveFile(url)}
                      className="h-[20px] w-[20px] bg-[#000000] flex items-center justify-center rounded-full"
                    >
                      <X size={14} color="#fff" />
                    </button>
                  </div>
                );
              })}
            </div>
          )}
          <div className="absolute bottom-[20px] left-[20px] right-[20px] flex items-center justify-between">
            <button
              onClick={handleBackToAmountFromFinalizeApproval}
              className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#222222] font-medium"
            >
              Back
            </button>
            <div className="flex items-center justify-center gap-[10px]">
              <button
                onClick={closeFinalizeApproval}
                className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
              >
                Cancel
              </button>
              <button
                disabled={approvalLoading}
                onClick={handleApproveLoan}
                className="h-[35px] bg-[#000000] flex items-center justify-center gap-[10px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
              >
                {approvalLoading && <Loading />}
                Approve Loan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Finalize;
